import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { WebhookAPI } from '@business/api/webhook';
import { WebhookId, WebhookResponse } from '@business/entities/webhook';
export class WebhookBloc extends BaseBloc {
  private readonly webhookRepo = new Repository<WebhookResponse>({
    getItemId: brand => brand.id,
  });

  readonly webhooks$ = this.webhookRepo.items$;

  onReset() {
    this.webhookRepo.reset();
  }

  fetchWebhooks = () => {
    return WebhookAPI.fetchWebhooks().pipe(this.webhookRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_webhook_error') }));
  };

  createWebhook = (webhook: Partial<WebhookResponse>) => {
    return WebhookAPI.createWebhook(webhook).pipe(
      this.webhookRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_webhook'),
      }),
    );
  };

  updateWebhook = (id: WebhookId, webhook: Partial<WebhookResponse>) => {
    return WebhookAPI.updateWebhook(id, webhook).pipe(
      this.webhookRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_webhook'),
      }),
    );
  };

  toggleWebhook = (id: WebhookId) => {
    return WebhookAPI.toggle(id).pipe(
      this.webhookRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_webhook'),
      }),
    );
  };

  deleteWebhook = (id: WebhookId) => {
    return showDeleteConfirmation('Delete Webhook', 'Do you really want to remove this webhook?').pipe(
      switchMap(() => WebhookAPI.deleteWebhook(id)),
      this.webhookRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_webhook'),
      }),
    );
  };
}
